import styled from 'styled-components';
import Link from 'next/link';
import { Typography } from '../../ui/Typography';

export const StyledAgencyCard = styled(Link)`
  display: flex;
  height: 105px;
  margin: 0 0 10px 9px;
  padding: 5px 0 5px 115px;
  box-shadow: 0 0 3px 0 rgba(255, 255, 255, 0.84);
  position: relative;
  box-sizing: border-box;
  background-color: ${({ theme: { colors } }) => colors.background.primary};
  text-decoration: none;
  width: 100%;

  span {
    margin-top: 5px;
  }
`;

export const AgencyLogo = styled.div`
  position: absolute;
  z-index: 1;
  left: 0;
  top: 0;
  width: 105px;
  height: 105px;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  border-right: 1px solid #e5e5e5;

  img {
    width: 100%;
    height: auto;
  }
`;

export const Title = styled(Typography).attrs({ tag: 'h2', $lineToShow: 1 })`
  margin: 0;
`;

export const OffersCount = styled(Typography).attrs({ tag: 'caption_1' })`
  color: ${({ theme: { colors } }) => colors.text.secondary};
  display: block;
`;
